import React, { useState, useEffect, useContext } from "react";
import { UserInformationContext } from "../main/App";
import { C4FStatusContext } from "../main/App";
import { LocalizationContext } from "../main/LocalizationContext";
import { ButtonGroup, Button, Row, Col, Container, Alert } from 'react-bootstrap';
import kapital from '../img/kapital.gif';
import geld_stapel from '../img/geld_stapel.gif';
import '../css/general.css';
import C4FSimpleTable from "../common/C4FSimpleTable";
import RaceFinancesModal from "../race/RaceFinancesModal";
import Chart from "react-apexcharts";
import moment from "moment";

function formatNumber(number = 0) {
  return number.toLocaleString();
}

function Finance(props) {
  const { userInformation } = useContext(UserInformationContext);
  const { getLocalizedText } = useContext(LocalizationContext);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const [tab, setTab] = useState('financeLog');
  const [subTab, setSubTab] = useState('races');
  const [team, setTeam] = useState(null);
  const [seasonOverview, setSeasonOverview] = useState([]);
  const [refresh, doRefresh] = useState(0);
  const [raceEditionForFinances, setRaceEditionForFinances] = useState(null);
  const [showFinances, setShowFinances] = useState(false);
  const handleCloseFinances = () => setShowFinances(false);

  function handleRaceDetails(financialTransaction) {
    handleBackendRequest('GET', '/raceEdition/' + financialTransaction.relatedObjectId, null,
      {
        context: 'raceEditionDetailsOnly'
      },
      function (raceEdition) {
        setShowFinances(true);
        raceEdition.currentStageForRaceEvents = financialTransaction.additionalRelatedObjectId ?
          financialTransaction.additionalRelatedObjectId : (financialTransaction.type === 'StageRace' ? 0 : 1)
        setRaceEditionForFinances({
          ...raceEdition,
          financialTransaction: raceEdition.currentStageForRaceEvents > 0 ?
            financialTransaction : null
        });
        doRefresh(p => p + 1);
      });
  }

  function processFinancialTransactions(financialTransactions) {

    financialTransactions.map(ft => ({
      ...ft,
      month: ft.date.substring(0, 7)
    }));

    // create trailing 24 months, assign month to all transaction
    let seasonOverview = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(monthsBack => {      
      let monthObject = moment().startOf('month').subtract(monthsBack, 'months');
      let month = monthObject.format('YYYY-MM');
      let monthFormatted = monthObject.format('MMMM YYYY');
      let currentFT = financialTransactions.filter(ft => ft.date.substring(0, 7) === month)

      let monthSummary = {
        month: month,
        monthFormatted: monthFormatted,
        oneDay: currentFT.filter(ft => ft.type === 'OneDayRace').reduce((sum, ft) => sum + ft.amount, 0),
        stage: currentFT.filter(ft => ft.type === 'Stage' ||  ft.type === 'StageMostActive').reduce((sum, ft) => sum + ft.amount, 0),
        stageRace: currentFT.filter(ft => ft.type === 'StageRace').reduce((sum, ft) => sum + ft.amount, 0),
        purchase: currentFT.filter(ft => ft.type === 'DirectBuy' || ft.type === 'Auction').reduce((sum, ft) => sum + ft.amount, 0),
        sale: currentFT.filter(ft => ft.type === 'Sale').reduce((sum, ft) => sum + ft.amount, 0),
        other: currentFT.filter(ft => ['Fine', 'NameChange', 'Correction', 'TeamReset'].includes(ft.type)).reduce((sum, ft) => sum + ft.amount, 0)
      };

      return {
        ...monthSummary,
        race: monthSummary.stage + monthSummary.stageRace + monthSummary.oneDay,
        transfer: monthSummary.sale + monthSummary.purchase,
        all: monthSummary.stage + monthSummary.stageRace + monthSummary.oneDay + monthSummary.sale + monthSummary.purchase + monthSummary.other
      }
    });
    return seasonOverview;
  }

  useEffect(() => {
    handleBackendRequest('GET', '/team/' + userInformation.userName, null,
      {
        returnFinanceDetails: true,
        returnRiders: true
      },
      function (team) {
        setTeam(team);
        setSeasonOverview(processFinancialTransactions(team.financialTransactions));
      }
    );
  }, [userInformation]);

  if (team !== null)
    return (
      <div className="container-fluid m-1">
        {raceEditionForFinances !== null ?
          <RaceFinancesModal key={'finances' + showFinances}
            raceEdition={raceEditionForFinances}
            teamName={userInformation.userName}
            show={showFinances}
            handleClose={handleCloseFinances} />
          : null}

        <div className="row d-flex pt-2 justify-content-center c4f-stats">
          <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
          <ButtonGroup>
            <Button variant={(tab === 'financeLog') ? 'primary py-1' : 'outline-primary py-1'} onClick={() => setTab("financeLog")}>Income &amp; Expenses</Button>
            <Button variant={(tab === 'season') ? 'primary py-1' : 'outline-primary py-1'} onClick={() => setTab("season")}>Seasons</Button>
          </ButtonGroup>
          </div>
        </div>

        <Row className=" pt-2 justify-content-center c4f-stats">
          <Col className="col-6 text-center">
            <img alt="stapel" src={geld_stapel} style={{ maxHeight: "60px" }}></img>
            <h4 className="mt-2">
              Current Balance: <span style={{ color: "green" }}>{formatNumber(team.balance)}</span>
            </h4>
          </Col>
          <Col className="col-6 text-center">
            <div>
              <img alt="kapital" src={kapital} style={{ maxHeight: "60px" }}></img>
            </div>
            <h4 className="mt-2">
              Total Capital: <span style={{ color: "green" }}>{formatNumber(team.teamValue)}</span>
            </h4>
          </Col>
        </Row>

          {(() => {
            if (tab === 'season') {
              let earnings = seasonOverview.slice().reverse();
              return <> 
              <div className="row d-flex pt-2 justify-content-center c4f-stats">
                  <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
                  <ButtonGroup>
                    <Button className="py-0 px-2" variant={(subTab === 'all') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('all')}>All</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'transfers') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('transfers')}>Transfers</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'races') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('races')}>Races</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'others') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('others')}>Others</Button>
                  </ButtonGroup>
                  </div>
                </div>
                <Row>
                <Col className="ml-4 mr-3 my-1 p-0" style={{ minWidth: 400, maxWidth: 1000 }}>
                <h5>Seasons - Prize Money and Profit</h5>
                <Container>
                  <div className="row d-flex pt-1 justify-content-center c4f-stats">
                  <div className="col my-1" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
                  <C4FSimpleTable key={'financesOverview' + refresh}
                    initialSortingColumn={'month'}
                    initialSortingAscending={false}
                    hideColumnVisibility={true}
                    hideFilterButtons={true}
                    data={seasonOverview}
                    rowMetadata={
                      [{ columnName: 'monthFormatted', columnDescription: 'Month', columnGroup: ' ' }]
                      .concat(subTab === 'all' || subTab ==='races' ? [
                      { columnName: 'oneDay', columnDescription: 'One-Day', columnGroup: 'Races', columnType: 'highlightedCurrency' },
                      { columnName: 'stage', columnDescription: 'Stages', columnGroup: 'Races', columnType: 'highlightedCurrency' },
                      { columnName: 'stageRace', columnDescription: 'Tours', columnGroup: 'Races', columnType: 'highlightedCurrency' },
                      { columnName: 'race', columnDescription: 'Total', columnGroup: 'Races', columnType: 'highlightedCurrency' }] : [])
                      .concat(subTab === 'all' || subTab ==='transfers' ? [
                      { columnName: 'purchase', columnDescription: 'Bought', columnGroup: 'Transfers', columnType: 'highlightedCurrency' },
                      { columnName: 'sale', columnDescription: 'Sold', columnGroup: 'Transfers', columnType: 'highlightedCurrency' },
                      { columnName: 'transfer', columnDescription: 'Total', columnGroup: 'Transfers', columnType: 'highlightedCurrency' }] : [])
                      .concat(subTab === 'all' || subTab ==='others' ? [
                      { columnName: 'other', columnDescription: 'Others', columnType: 'highlightedCurrency', columnGroup: '  ' }] : [])
                      .concat(subTab === 'all' ? [
                      { columnName: 'all', columnDescription: 'Profit', columnType: 'highlightedCurrency', columnGroup: '  ' }] : [])
                    }
                  />
                  </div>
                </div>
                </Container>
                <Container fluid className="p-1 mt-2">
                  <h5>Chart - Race Earnings by Type</h5>
                  <Chart type="bar" options={{
                    chart:{
                      stacked: true
                    },
                    xaxis: {
                      categories: earnings.map(season => season.monthFormatted)
                    },
                    yaxis: {
                      labels: {
                        formatter: function(value) {
                          if (value >= 1000) {
                            // You can use a comma separator for thousands
                            return value.toLocaleString(); 
                          } else {
                            return value;
                          }
                        }
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function(value) {
                        return value.toLocaleString();
                      }
                    }
                  }}
                    series={[
                      {
                        name: "Tours",
                        data: earnings.map(season => season.stageRace),
                        hidden: false
                      },
                      {
                        name: "Stages",
                        data: earnings.map(season => season.stage),
                        hidden: false
                      },
                      {
                        name: "One Day Races",
                        data: earnings.map(season => season.oneDay),
                        hidden: false
                      },
                      /* commented out as it's not very relevant
                      {
                        name: "Transfers",
                        data: earnings.map(season => season.transfer),
                        hidden: true
                      },
                      {
                        name: "Others",
                        data: earnings.map(season => season.other),
                        hidden: true
                      },
                      {
                        name: "All",
                        data: earnings.map(season => season.all),
                        hidden: true
                      }
                      */
                    ]} />
                </Container>
              </Col>
            </Row>
            </>
            }
            if (tab === 'financeLog')
              return <>
                <div className="row d-flex pt-2 justify-content-center c4f-stats">
                  <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
                  <ButtonGroup>
                    <Button className="py-0 px-2" variant={(subTab === 'all') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('all')}>All</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'transfers') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('transfers')}>Transfers</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'races') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('races')}>Races</Button>
                    <Button className="py-0 px-2" variant={(subTab === 'others') ? 'secondary' : 'outline-secondary'}
                      onClick={() => setSubTab('others')}>Others</Button>
                  </ButtonGroup>
                  </div>
                </div>
                <Row>
                <Col className="ml-4 mr-3 my-1 p-0 justify-center" style={{ minWidth: 400, maxWidth: 1000 }}>

                <h5>Financial Transactions ({subTab})</h5>

                {team && team.financialTransactions ?
                  <>
                    {subTab === 'all' ?
                      <C4FSimpleTable key={'financesAll' + refresh}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        data={team.financialTransactions
                          .map(ft => ({
                            ...ft,
                            typeLocalized: getLocalizedText('referenceData', 'FinancialTransactionType' + ft.type),
                            relatedObjectNameShort: ft.relatedObjectName.length > 40 ? ft.relatedObjectName.substring(0, 37) + '...' : ft.relatedObjectName
                          }))}
                        rowMetadata={[
                          { columnName: 'date', columnDescription: 'Date' },
                          { columnName: 'oldBalance', columnDescription: 'Before', columnType: 'currency' },
                          { columnName: 'amount', columnDescription: 'Amount', columnType: 'highlightedCurrency' },
                          { columnName: 'newBalance', columnDescription: 'After', columnType: 'currency' },
                          { columnName: 'typeLocalized', columnDescription: 'Type' },
                          { columnName: 'relatedObjectNameShort', columnDescription: 'Description' }
                        ]}
                      />
                      : null}
                    {subTab === 'transfers' ?
                      <C4FSimpleTable key={'financesTransfers' + refresh}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        data={team.financialTransactions
                          .filter(ft => ['Sale', 'DirectBuy', 'Auction'].includes(ft.type))
                          .map(ft => ({
                            ...ft,
                            typeLocalized: getLocalizedText('referenceData', 'FinancialTransactionType' + ft.type)
                          }))}
                        rowMetadata={[
                          { columnName: 'date', columnDescription: 'Date' },
                          { columnName: 'amount', columnDescription: 'Amount', columnType: 'highlightedCurrency' },
                          { columnName: 'typeLocalized', columnDescription: 'Type' },
                          { columnName: 'relatedObjectName', columnDescription: 'Description' }
                        ]}
                      />
                      : null}
                    {subTab === 'races' ?
                      <C4FSimpleTable key={'financesRaces' + refresh}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        data={team.financialTransactions
                          .filter(ft => ['Stage', 'StageMostActive', 'StageRace', 'OneDayRace'].includes(ft.type))
                          .map(ft => ({
                            ...ft,
                            typeLocalized: getLocalizedText('referenceData', 'FinancialTransactionType' + ft.type),
                            relatedObjectNameShort: ft.relatedObjectName.length > 50 ? ft.relatedObjectName.substring(0, 47) + '...' : ft.relatedObjectName,
                            detailButton: '+'
                          }))}
                        rowMetadata={[
                          { columnName: 'date', columnDescription: 'Date' },
                          { columnName: 'amount', columnDescription: 'Amount', columnType: 'highlightedCurrency' },
                          { columnName: 'typeLocalized', columnDescription: 'Type' },
                          { columnName: 'relatedObjectNameShort', columnDescription: 'Race' },
                          { columnName: 'detailButton', columnDescription: 'Details', columnType: 'button', cellClickEvent: handleRaceDetails, className: 'py-0 btn-secondary' }
                        ]}
                      />
                      : null}
                    {subTab === 'others' ?
                      <C4FSimpleTable key={'financesOthers' + refresh}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        data={team.financialTransactions
                          .filter(ft => ['Fine', 'NameChange', 'Correction', 'TeamReset'].includes(ft.type))
                          .map(ft => ({
                            ...ft,
                            typeLocalized: getLocalizedText('referenceData', 'FinancialTransactionType' + ft.type)
                          }))}
                        rowMetadata={[
                          { columnName: 'date', columnDescription: 'Date' },
                          { columnName: 'amount', columnDescription: 'Amount', columnType: 'highlightedCurrency' },
                          { columnName: 'type', columnDescription: 'Type' },
                          { columnName: 'relatedObjectName', columnDescription: 'Description' }
                        ]}
                      />
                      : null}
                  </>

                  : null}

              </Col>
              </Row>
              </>
          })()}

      </div>
    );
  else return null;
}

export default Finance;
